import { Call } from '../../../utils/multicall'
import {
  getAaveAssets,
  getAaveTypePoolDataProviderAddress,
  getAaveTypePoolAddress,
} from '../../../assets'
import { isYLDR } from '@1delta/lender-registry'
import { buildAaveLensCall, usesAaveLens } from './lens'

const getBaseAaveV3Calls = (
  chainId: string,
  account: string,
  lender: string,
  assetsToQuery: string[],
) => {
  return assetsToQuery.flatMap((tk) => [
    {
      address: getAaveTypePoolDataProviderAddress(chainId, lender),
      name: 'getUserReserveData',
      params: [tk, account],
    },
  ])
}

export const buildAaveV3UserCall = (
  chainId: string,
  lender: string,
  account: string,
): Call[] => {
  const assetsToQuery = getAaveAssets(chainId, lender).sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase()),
  )

  const withEMode = !isYLDR(lender)

  // A chain without a lens deployment keeps the per-reserve walk. That is the
  // rollout switch and the emergency revert both.
  //
  // YLDR is deliberately excluded: it has its OWN converter
  // (`userCallParseYldr.ts`) reading a DIFFERENT field enum, so routing its
  // builder through the lens would hand walk-shaped expectations a blob. The
  // builder and the converter must agree per lender, not per chain.
  if (withEMode && usesAaveLens(chainId, lender)) {
    return buildAaveLensCall(
      chainId,
      lender,
      account,
      assetsToQuery,
      withEMode,
    )
  }

  const calls = [...getBaseAaveV3Calls(chainId, account, lender, assetsToQuery)]
  if (withEMode) {
    const callDataEmode = {
      address: getAaveTypePoolAddress(chainId, lender),
      name: 'getUserEMode',
      params: [account],
    }
    calls.push(callDataEmode)
  }

  return calls
}
